export const useStyles = () => {
  return ({
    containerSuccess: ({isSelected}:{isSelected: boolean}) => ({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      '& .crud-filter-container': {
        paddingTop: '10px',
      },
      '& .table-container': {
        overflowY: 'auto',
        '& table': {
          position: 'relative'
        },
      },
      ...!!isSelected && {
        '& .table-parent': {
          width: 'calc(100% + 30px)',
          marginLeft: '-30px'
        }
      }
    }),
    container: {
      position: 'relative',
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      '& .filterContainer-main': {
        paddingLeft: '25px'
      }
    },
    search: {
      width: '200px',
    },
    closeSuccess: {
      position: 'absolute',
      right: '10px',
      top: '15px',
    },
    button: {
      width: 'fit-content',
      alignSelf: 'end',
      marginTop: '20px'
    },
    filter: {
      width: '200px'
    },
    title: {
      fontSize: "1.4rem",
      fontWeight: '500'
    },
    header: {
      width: '100%',
      display: 'flex',
      flexWrap: 'wrap',
      justifyContent: 'space-between',
      alignItems: 'center',
      marginBottom: '20px'
    },
  })
}
